module.exports = __webpack_public_path__ + "img/logoltingsamll.b3a58f0a.png";